import React from 'react';
import { Link } from 'react-router-dom';
import './../styles/landing.css';

const Home = () => {
  return (
    <div className="landing-page">
      <header className="hero">
        <h1>Helping you make informed decisions.</h1>
        <p>Manage your content efficiently with our powerful dashboard</p>
        <div className="cta-buttons">
          <Link to="/login" className="btn-primary">
            Login
          </Link>
          <Link to="/contact" className="btn-secondary">
            Contact Us
          </Link>
        </div>
      </header>

      <section className="features stagger">
        <div className="feature animate-fade-up">
          <h3>What We Do</h3>
          <p>
            We track and analyse mentions of brands, clients or industry topics online — across news websites, social platforms, and digital media.
          </p>
        </div>
        <div className="feature animate-fade-up">
          <h3>How It Works</h3>
          <p>
            We monitor platforms like Meta, X, TikTok, Truth Social, and more. Share your keywords and phrases, and our application tracks mentions, extracts content, derives sentiment, and generates comprehensive reports.
          </p>
        </div>
        <div className="feature animate-fade-up">
          <h3>Data Analytics</h3>
          <p>
            We offer comprehensive media monitoring and analysis across print, broadcast, online, and social media — helping businesses make informed decisions about their market strategy.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
